import React, { useState } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { CreateOrganizationSuccess } from '../../Redux/OrganizationSlice';
import toast from 'react-hot-toast';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';

const CreateOrganizationModal = ({ showModal, setShowModal }) => {
  const dispatch = useDispatch();
  const { users, user, _roles } = useSelector(
    state => ({
      users: state.Users.users,
      user: state.User.user,
      _roles: state.Roles._roles,
    }),
    shallowEqual
  );
  // const { _roles } = useSelector((state) => state.Roles);
  const [selected, setSelected] = useState([]);
  const [organizationInput, setOrganizationInput] = useState({
    name: '',
    email: '',
    password: '',
    code: '',
    roles: [],
    users: [],
  });
  function closeModal() {
    setOrganizationInput({
      name: '',
      email: '',
      password: '',
      code: '',
      roles: [],
      users: [],
    });
    setShowModal(false);
  }
  const inputHandle = e => {
    const { name, value } = e.target;
    setOrganizationInput(prev => {
      let _value = value.split('-');
      if (name === 'procedures') {
        return {
          ...prev,
          [name]: [...prev.procedures, { id: _value[0], name: _value[1] }],
        };
      }
      if (name == 'roles') {
        // const _value=value.split('-');
        return {
          ...prev,
          [name]: [...prev.roles, { id: _value[0], name: _value[1] }],
        };
      } else if (name == 'users') {
        // const _value = value.split("-");
        return {
          ...prev,
          [name]: [...prev.users, { id: _value[0], name: _value[1] }],
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };
  const submitOrganization = async () => {
    try {
      const { status, data } = await api.post('/org/org-register', {
        org: organizationInput,
      });
      if (status === 201) {
        toast.success('Organization create successfully.');
        dispatch(CreateOrganizationSuccess(data.organization));
        setOrganizationInput({
          name: '',
          email: '',
          password: '',
          code: '',
          // procedures: [],
          roles: [],
          users: [],
        });
        closeModal();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const rolesOptions = _roles.map(role => ({
    value: `${role._id}-${role.name}`,
    label: role.name,
  }));

  // Handle selection change
  const handleChange = selectedOption => {
    if (selectedOption) {
      const [id, name] = selectedOption.value.split('-');
      setOrganizationInput(prev => ({
        ...prev,
        roles: [...prev.roles, { id, name }],
      }));
    }
  };

  return (
    <div>
      {showModal && (
        <Modal
          isOpen={showModal}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={{
            content: {
              width: '50%',
              height: '52%',
              margin: 'auto',
              borderRadius: '20px',
              padding: 0,
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
        >
          <div className="flex justify-between  mx-5 my-3">
            <h1 className="text-2xl font-semibold">Create Organization</h1>
            <button onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </button>
          </div>
          <hr />

          <div className="flex justify-between items-center mx-5 my-3 gap-5">
            <div>
              <div className="flex justify-between gap-5 my-3">
                <div>
                  <p>
                    Organization Name<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-full border rounded-lg text-sm outline-none  my-1"
                    type="text"
                    id="organizationName"
                    placeholder="Enter Name"
                    name={'name'}
                    value={organizationInput.name}
                    onChange={inputHandle}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5 my-3">
                <div>
                  <p>
                    Code<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none  my-1"
                    type="text"
                    id="code"
                    placeholder="Enter Code"
                    name={'code'}
                    value={organizationInput.code}
                    onChange={inputHandle}
                  />
                </div>
                {/* <div>
                  <p>
                    Email<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none  my-1"
                    type="text"
                    id="email"
                    placeholder="Enter Email"
                    name={'email'}
                    value={organizationInput.email}
                    onChange={inputHandle}
                  />
                </div>
                <div>
                  <p>
                    Password<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none  my-1"
                    type="password"
                    id="password"
                    placeholder="Enter Password"
                    name={'password'}
                    value={organizationInput.password}
                    onChange={inputHandle}
                  />
                </div> */}
              </div>
              {/* <div>
                <MultiSelect
                options={users.map(u=>({label:u.firstName,value:u.firstName}))}
                value={selected}
                onChange={setSelected}
                labelledBy="Select"
                className="z--index"
                />
              </div> */}
              {/* <div>
                <p>
                  Assign Procedures<span className="text-red-500">*</span>
                </p>
                <select
                  className="p-2 w-full border rounded-lg text-sm outline-none  my-1"
                  id="assignProcedures"
                  name={"procedures"}
                  // value={organizationInput.procedures[organizationInput.procedures.length]}
                  onChange={inputHandle}
                >
                  <option>--select procedure--</option>
                  {procedures.map((pro, index) => (
                    <option key={index} value={`${pro._id}-${pro.name}`}>
                      {pro?.name}
                    </option>
                  ))}
                </select>
              </div> */}

              <div>
                <p>
                  Assign Roles<span className="text-red-500">*</span>
                </p>

                {/* <select
                  className="p-2 w-full border rounded-lg text-sm outline-none  my-1"
                  id="assignProcedures"
                  name={"roles"}
                  // value={organizationInput.procedures[organizationInput.procedures.length]}
                  onChange={inputHandle}
                >
                  <option>--Select Role--</option>
                  {_roles.map((_role, index) => (
                    <option key={index} value={`${_role._id}-${_role.name}`}>
                      {_role?.name}
                    </option>
                  ))}
                </select> */}

                <Select
                  className="w-full  text-sm my-1"
                  options={rolesOptions}
                  onChange={handleChange}
                  placeholder="--Select Role--"
                />
              </div>

              {/* <div>
                <p>
                  Assign Users<span className="text-red-500">*</span>
                </p>
                <select
                  className="p-2 w-full border rounded-lg text-sm outline-none  my-1"
                  id="assignProcedures"
                  name={"users"}
                  // value={organizationInput.procedures[organizationInput.procedures.length]}
                  onChange={inputHandle}
                >
                  <option>--select users--</option>
                  {users.map((u, index) => (
                    <option
                      key={index}
                      value={`${u._id}-${u.firstName + " " + u.lastName}`}
                    >
                      {`${u?.firstName} ${u?.lastName}`}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>

            <div className="w-full ">
              <h3>Roles List</h3>
              <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
                {organizationInput.roles.map((_pro, _index) => {
                  return (
                    <div className="flex justify-between">
                      <p>{_pro.name}</p>
                      <MdDelete
                        className="cursor-pointer"
                        onClick={() => {
                          setOrganizationInput(prev => ({
                            ...prev,
                            roles: prev.roles.filter(
                              (__pro, __index) => __index !== _index
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* <div className="w-full ">
              <h3>Users List</h3>
              <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
                {organizationInput.users.map((_pro, _index) => {
                  return (
                    <div className="flex justify-between">
                      <p>{_pro.name}</p>
                      <MdDelete
                        className="cursor-pointer"
                        onClick={() => {
                          setOrganizationInput((prev) => ({
                            ...prev,
                            users: prev.users.filter(
                              (__pro, __index) => __index !== _index
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div> */}
          </div>
          <div className=" flex justify-end mx-5 my-3 gap-3">
            <button
              onClick={closeModal}
              className="border border-red-500 p-1 px-5 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={submitOrganization}
              className="border bg-red-500 p-1 px-5 rounded-lg text-white"
            >
              Save & Update
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CreateOrganizationModal;
